import { FlowCanvas } from './flow-canvas';
import { FlowSidebar } from './sidebar/flow-sidebar';
import { FieldMappingPanel } from './panels/field-mapping-panel';
import { VariableFormPanel } from './panels/variable-form-dialog';
import { ConditionConfig } from './condition/condition-config';
import { useFlowBuilderStore } from '@/stores/flow-builder-store';
import { Loader2 } from 'lucide-react';

export function FlowBuilder() {
  const loading = useFlowBuilderStore((s) => s.loading);
  const error = useFlowBuilderStore((s) => s.error);
  const fieldMappings = useFlowBuilderStore((s) => s.fieldMappings);
  const fieldMappingPanelOpen = useFlowBuilderStore((s) => s.fieldMappingPanelOpen);
  const variableFormOpen = useFlowBuilderStore((s) => s.variableFormOpen);
  const editingConditionId = useFlowBuilderStore((s) => s.editingConditionId);
  const setEditingConditionId = useFlowBuilderStore((s) => s.setEditingConditionId);

  // Show spinner while loading OR before data arrives (e.g. after reset(),
  // between remount and fetchFieldMappings starting). Never reveal an empty canvas.
  const hasData = Object.keys(fieldMappings).length > 0;

  if (loading || !hasData) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <p className="text-sm text-muted-foreground">Loading field mappings...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex flex-col items-center gap-2 text-center">
          <p className="text-sm font-medium text-destructive">Failed to load</p>
          <p className="max-w-sm text-xs text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full">
      {/* Flow Canvas (takes remaining space) */}
      <div className="relative flex-1">
        <FlowCanvas />

        {/* Condition Config Editor (floating panel over canvas) */}
        {editingConditionId && (
          <ConditionConfig
            docId={editingConditionId}
            onClose={() => setEditingConditionId(null)}
          />
        )}

        {/* Field Mapping Panel (slides from right, over canvas) */}
        {fieldMappingPanelOpen && <FieldMappingPanel />}

        {/* Variable Form Panel (slides from right, over canvas) */}
        {variableFormOpen && <VariableFormPanel />}
      </div>

      {/* Sidebar */}
      <FlowSidebar />
    </div>
  );
}
